export default __webpack_public_path__ + "static/media/about-bg.30a77dee.png";